/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SubtitleInputs */

const es_feedback_subtitle = /** @type {(inputs: Feedback_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona tus reportes`)
};

const en_feedback_subtitle = /** @type {(inputs: Feedback_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your reports`)
};

/**
* | output |
* | --- |
* | "Manage your reports" |
*
* @param {Feedback_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_subtitle = /** @type {((inputs?: Feedback_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_subtitle(inputs)
	return en_feedback_subtitle(inputs)
});
export { feedback_subtitle as "feedback.subtitle" }